import { getFunctions, httpsCallable } from 'firebase/functions'
import firebaseApp from '../plugins/firebase'

const functions = getFunctions(firebaseApp)

export const knowledgeBaseService = {
  async manageArticle(articleData) {
    const manageArticleFunction = httpsCallable(functions, 'manageArticle')
    return manageArticleFunction(articleData)
  }
}

export const qualityService = {
  async createEvaluation(evaluationData) {
    const createEvaluationFunction = httpsCallable(functions, 'createEvaluation')
    return createEvaluationFunction(evaluationData)
  }
}

export const analyticsService = {
  async getAnalyticsData(params) {
    const getAnalyticsDataFunction = httpsCallable(functions, 'getAnalyticsData')
    return getAnalyticsDataFunction(params)
  }
}

export const workflowService = {
  async saveWorkflow(workflowData) {
    const saveWorkflowFunction = httpsCallable(functions, 'saveWorkflow')
    return saveWorkflowFunction(workflowData)
  }
}

export const monitoringService = {
  async getMonitoringData() {
    const getMonitoringDataFunction = httpsCallable(functions, 'getMonitoringData')
    return getMonitoringDataFunction()
  }
}

export const securityService = {
  async updateSecuritySettings(settings) {
    const updateSecuritySettingsFunction = httpsCallable(functions, 'updateSecuritySettings')
    return updateSecuritySettingsFunction({ settings })
  }
}